<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { api, clientSettings } from '../../../stores/api.js';
    import { JobApi } from './JobApi.js';
    import { ImportApi } from '../Import/ImportApi.js';
    import { get } from 'svelte/store';
    import FormSection from './FormSection.svelte';
    import FormRow from './FormRow.svelte';
    import SuccessInline from '../../shared/SuccessInline.svelte';
    import TemplateExpandedSection from './TemplateExpandedSection.svelte';
    import IconLocationOn from '../../shared/Icons/IconLocationOn.svelte';
    import ErrorColor from '../../shared/ErrorColor.svelte';
    import Label from './Label.svelte';
    import InputText from '../../shared/InputText.svelte';
    import SelectHour from '../../shared/SelectHour.svelte';
    import TemplateExpandedSectionButtons from './TemplateExpandedSectionButtons.svelte';
    import Spinner from '../../shared/Spinner/Spinner.svelte';
    import ErrorInline from '../../shared/ErrorInline.svelte';
    import ButtonSmallBlack from '../../shared/ButtonSmallBlack.svelte';
    import SelectDay from '../../shared/SelectDay.svelte';
    import { Job } from './Job';
    import { debug, defaultPageLink, mainMenu, planning } from '../../../stores/store';
    import { jobInitialData } from './jobInitialData';
    import {
        JobRequestSchema,
        type JobRequestType,
        JobResponseSchema,
        type JobResponseType,
    } from './types.js';
    import SearchForm from '../../shared/SearchForm.svelte';
    import VehicleOneLabel from '../Vehicles/VehicleOneLabel.svelte';
    import VehicleOneParagraph from '../Vehicles/VehicleOneParagraph.svelte';
    import VehicleOneSection from '../Vehicles/VehicleOneSection.svelte';
    import VehicleOneValue from '../Vehicles/VehicleOneValue.svelte';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';
    import Select from '../../shared/Select.svelte';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import ButtonSecondary from '../../shared/ButtonSecondary.svelte';
    import ButtonSmallBlue from '../../shared/ButtonSmallBlue.svelte';
    import MessageDangerSmall from '../../shared/Messages/MessageDangerSmall.svelte';
    import TemplateRow from '../../shared/TemplateRow.svelte';
    import { extractFieldsFromB } from '../../utilities/SchemaManager.js';
    import { getJobLabel, getJobPin, JobsOnMap } from './JobsOnMap';
    import { JobOnMap } from './JobOnMap';
    import { onMount } from 'svelte';
    import { onMapReady } from '../../utilities/onMapReady';
    import IconRemove from '../../shared/Icons/IconRemove.svelte';
    import IconRemoveFilter from '../../shared/Icons/IconRemoveFilter.svelte';
    import InputNumber from '../../shared/InputNumber.svelte';
    import { ResolutionTime } from '../telematics/components/Colorizer/ResolutionTime';
    import { ResolutionDate } from '../telematics/components/Colorizer/ResolutionDate';
    import IconPending from '../../shared/Icons/IconPending.svelte';
    import { JobValidator } from './JobValidator';
    import ErrorBounduary from './ErrorBounduary.svelte';
    import { BalloonContentGenerator } from './BalloonContentGenerator';
    import { Navigation } from '../../utilities/Navigation';
    import InputSuggest from '../../shared/InputSuggest.svelte';
    import IconAddSimple from '../../shared/Icons/IconAddSimple.svelte';
    import DualList from '../../shared/DualList.svelte';
    import { Umami } from '../../utilities/Umami';

    export let job: Job;
    export let startPointOnMap: () => void;
    export let jobOnMap: JobOnMap;
    export let jobGeocodedOnMap: JobOnMap;
    export let triedToSave: boolean = false;

    // let target_date: string = $planning.selectedDay;
    let savingError: string = '';
    let validateError: string = '';
    let saving: boolean = false;
    let loading: boolean = true;

    let latestHover: boolean = false;
    let targetHover: boolean = false;
    let earliestHover: boolean = false;

    let savedData: Job = new Job();

    let savedWithSuccess: boolean = false;

    let jobTypeItems = [
        { id: 'delivery', label: $_('Dostawa') },
        { id: 'collection', label: $_('pickup') },
    ];

    let clientAttributes = filterClientAttributes();
    let allClientAttributes: string[] = [];
    let newClientAtrributeName: string = '';
    let newClientAttributeValid: boolean = true;
    let newClientAtrributeValue: string = '';
    let newClientAttributeInput: HTMLInputElement;
    let attributeVisibility: any[] = [];

    function fillWithExampleData() {
        job.setTargetDate($planning.selectedDay);

        job.getData().address_attributes = {
            country: 'PL',
            city: 'Warszawa',
            pcode: '00-001',
            street: 'Marszałkowska',
            house: '1',
            apartment: '',
            community: 'Śródmieście',
            province: 'mazowieckie',
            quarter: 'Stare Miasto',
        };

        job.getData().special_attributes = {
            parcels: 1,
            total_weight: 100,
            fill_percentage: 100,
            external_id: '123456',
            delivery_or_collection: 'delivery',
            earliest_delivery_date: $planning.selectedDay,
            latest_delivery_date: $planning.selectedDay,
            start_of_time_window: '08:00',
            end_of_time_window: '16:00',
        };

        job = job;
    }

    function fillWithSavedData() {
        triedToSave = false;
        job.set(JSON.parse(JSON.stringify(savedData.getData())));
        job.getData().id = -1;
        job = job;
    }

    function filterClientAttributes() {
        let unassignedAttributes = {...job.getData()?.client_attributes ?? {}};
        if (job.getData()?.import?.columns_assignment) {
            let caElements = job.getData()?.import?.columns_assignment?.elements ?? [];
            let caOptions = job.getData()?.import?.columns_assignment?.options ?? [];
            for (let i = 0; i < caElements.length; i++) {
                if (caElements[i].type === 'select' && caElements[i].selectedOptionId !== '') {
                    let selectedOptions = caElements[i].selectedOptionId.split(',');
                    for (let j = 0; j < selectedOptions.length; j++) {
                        let caOption = caOptions.filter((o) => o.id == selectedOptions[j])[0] ?? null;
                        if (caOption) {
                            delete(unassignedAttributes[caOption.label]);
                        }
                    }
                }
            }
        }
        return unassignedAttributes;
    }

    function onClientAttributeRemove(key) {
        delete(job.getData()?.client_attributes[key]);
        clientAttributes = filterClientAttributes();
        let vispos = attributeVisibility.map(av => av.id).indexOf('client/'+key);
        if (vispos >= 0) {
            attributeVisibility.splice(vispos, 1);
            attributeVisibility = attributeVisibility;
        }
    }

    function onClientAttributeAdd() {
        if (newClientAtrributeName && newClientAttributeValid) {
            job.getData().client_attributes[newClientAtrributeName] = newClientAtrributeValue;
            clientAttributes = filterClientAttributes();
            attributeVisibility.push({id: 'client/'+newClientAtrributeName, label: newClientAtrributeName, disabled: false, selected: true, order: null});
            attributeVisibility = attributeVisibility;
            newClientAtrributeName = '';
            newClientAtrributeValue = '';
            newClientAttributeInput.focus();
        }
    }

    function validate(job: Job): boolean {
        console.log('Validating job', job.getData());

        validateError = '';

        if (!JobValidator.checkStartEndOfTimeWindow(job)) {
            validateError = 'Start of time window cannot be later than end of time window';
            return false;
        }

        if (!JobValidator.checkTargetDateBetweenEarliestLatestDeliveryDate(job)) {
            validateError = 'Target date must be between earliest and latest delivery date';
            return false;
        }

        if (!JobValidator.checkEarliestBeforeLatestDeliveryDate(job)) {
            validateError = 'Earliest delivery date cannot be later than latest delivery date';
            return false;
        }

        if (!JobValidator.checkTargetDateAfterEarliestDeliveryDate(job)) {
            validateError = 'Target date must be after earliest delivery date';
            return false;
        }

        if (!JobValidator.checkTargetDateBeforeLatestDeliveryDate(job)) {
            validateError = 'Target date must be before latest delivery date';
            return false;
        }

        if (!job.coordsSetManually()) {
            // check if city is not empty
            // if (!job.getData()?.address_attributes?.city) {
            if (!JobValidator.checkCityNotEmpty(job)) {
                validateError = 'City cannot be empty';
                return false;
            }

            // check if street is not empty
            // if (!job.getData()?.address_attributes?.street) {
            if (!JobValidator.checkStreetNotEmpty(job)) {
                validateError = 'Street cannot be empty';
                return false;
            }
        }

        // check if fill percentage is between 0 and 100
        // if (job.getData()?.special_attributes?.fill_percentage && (job.getData()?.special_attributes?.fill_percentage < 0 || job.getData()?.special_attributes?.fill_percentage > 100)) {
        if (!JobValidator.checkFillPercentageBetween0And100(job)) {
            validateError = 'Fill percentage must be between 0 and 100';
            return false;
        }

        if (!JobValidator.checkNumberOfParcelsIsPositive(job)) {
            validateError = 'Number of parcels must be positive';
            return false;
        }

        if (!JobValidator.checkIfTotalWeightIsPositive(job)) {
            validateError = 'Total weight must be positive';
            return false;
        }

        return true;
    }

    async function saveJob(withGeocoding: boolean = true) {
        saving = true;
        triedToSave = true;
        savingError = '';

        if (job.getData()?.id < 0) {
            let visibleAttributes = attributeVisibility.filter(a => a.selected);
            visibleAttributes.sort((a, b) => (a.order ?? 9999) - (b.order ?? 9999));
            let columnAssignment: {options: any[], elements: any[]} = {options: [], elements: []};
            for (let i = 0; i < visibleAttributes.length; i++) {
                let va = visibleAttributes[i];
                columnAssignment.options.push({id: va.id, label: va.label});
                columnAssignment.elements.push(
                    {
                        id: va.id.split('/')[1],
                        label: va.id.split('/')[1],
                        section: va.id.split('/')[0],
                        selectedOptionId: va.id,
                        type: 'select',
                        availableOptions: []
                    },
                    {
                        id: va.id,
                        label: va.id.split('/')[1],
                        section: 'columnVisibility',
                        checked: true,
                        order: va.order,
                        type: 'checkbox'
                    }
                );
            }
            let newImport = await ImportApi.create($api, {
                name: 'import_' + new Date().toISOString().slice(0, 10),
                import_type: 'upsert',
                file_type: 'locations',
                columns_assignment: columnAssignment
            });
            if (newImport && job.getData()) {
                job.getData().import_id = newImport.id;
            }
        }

        let jobRequest: JobRequestType = extractFieldsFromB<JobRequestType>(
            job.getData(),
            JobRequestSchema
        );
        try {
            JobRequestSchema.parse(jobRequest);
        } catch (e) {
            console.error('Error validating job request', e);
            savingError = e?.message || 'Error validating job request';
            return;
        }

        const isNewJob = job.getData()?.id < 0;
        let createOrUpdate =
            isNewJob
                ? JobApi.createOne(get(api), jobRequest)
                : JobApi.updateOne(get(api), job.getData()?.id, jobRequest);
        let savedJob = await createOrUpdate.catch(err => {
            Umami.error(isNewJob ? 'job_created' : 'job_edited', err);
            console.error('Error saving job', err);
            savingError = err;
        });

        if (savedJob) {
            if (isNewJob) {
                Umami.event('job_created', { job_id: savedJob.id });
            } else {
                Umami.event('job_edited', { job_id: savedJob.id });
            }
            job.set(savedJob);
            if (
                job.getData()?.geom &&
                job.getData()?.geom?.coordinates &&
                job.getData()?.geom?.coordinates[0] &&
                job.getData()?.geom?.coordinates[1]
            ) {
                if (!job.coordsSetManually()) {
                    jobOnMap.addPoint(
                        job.getData()?.geom?.coordinates[0],
                        job.getData()?.geom?.coordinates[1],
                        '#70a0ff',
                        new BalloonContentGenerator(job).getBalloonHtmlArray().join('')
                    );
                    jobOnMap.centerMap();
                }
                jobGeocodedOnMap.addPoint(
                    job.getData()?.geom?.coordinates[0],
                    job.getData()?.geom?.coordinates[1],
                    '#cccccc',
                    new BalloonContentGenerator(job).getBalloonHtmlArray().join('')
                );
                jobGeocodedOnMap.centerMap();
            }
            job = job;
            savedData.set(JSON.parse(JSON.stringify(job.getData())));
            savedData = savedData;
        }

        saving = false;

        console.log('Saving job', job);
    }

    onMount(() => {
        Promise.all([
            JobApi.getDataForNewJob($api),
            onMapReady()
        ])
            .then((response) => {
                allClientAttributes = response[0]?.all_client_attributes ?? [];
                for (let section in response[0].columns) {
                    for (let attr in response[0].columns[section]) {
                        let attrdata = response[0].columns[section][attr];
                        if (typeof(attrdata.visible) !== 'boolean' || attrdata.visible) {
                            attributeVisibility.push({id: section+'/'+attr, label: $_('rpc_upload_param_label_'+attrdata.label), disabled: typeof(attrdata.visible) === 'boolean', selected: attrdata.visible, order: attrdata.order});
                        }
                    }
                }
                if (
                    job.getData()?.geom &&
                    job.getData()?.geom?.coordinates &&
                    job.getData()?.geom?.coordinates[0] &&
                    job.getData()?.geom?.coordinates[1]
                ) {
                    jobOnMap.addPoint(
                        job.getData()?.geom?.coordinates[0],
                        job.getData()?.geom?.coordinates[1],
                        '#70a0ff',
                        'Zlecenie'
                    );
                    jobOnMap.centerMap();
                }
                loading = false;
            })
            .catch(e => {
                console.error('Error loading map', e);
            });

        return () => {
            jobOnMap.clear();
            jobGeocodedOnMap.clear();
        };
    });

    $: validate(job);

    $: {
        savedWithSuccess = triedToSave && !saving && !savingError && !validateError;

        if (savedWithSuccess) {
            Navigation.navigate(defaultPageLink);
        }
    }
</script>

{#if loading}
    <Spinner />
{:else}
    <div class="job-edit-form">
        {#if $debug}
            <ButtonSmallBlack text="Fill with example data" on:click={fillWithExampleData} />
        {/if}

        {#if job.getData()?.id < 0 && savedData && savedData.getData()?.id >= 0}
            <div
                style="margin:0 40px; display: flex; justify-content: flex-end; align-items: center;"
            >
                <ButtonSmallBlack text={$_('Use saved data')} on:click={fillWithSavedData} />
            </div>
        {/if}

        <VehicleOneParagraph>
            <div slot="title">Realizacja</div>
            <div slot="content">
                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('target_date')}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <div
                            style="border-radius:3px; padding: 0 3px; display: flex; align-items: center; flex-direction: row; column-gap: 10px; justify-content: flex-start; width: 100%; font-size: var(--font-size-tactical-plan); position: relative;"
                            on:mouseenter={() => {
                                targetHover = true;
                            }}
                            on:mouseleave={() => {
                                targetHover = false;
                            }}
                            class:invalid-input={false}
                        >
                            <SelectDay
                                valid={JobValidator.checkTargetDateBetweenEarliestLatestDeliveryDate(
                                    job
                                )}
                                minDay={new Date().toISOString().substring(0, 10)}
                                showRelativeToday={$clientSettings.display.showRelativeToday}
                                day={job.getTargetDate() || ''}
                                onChange={d => {
                                    console.log('Selecting target_date for job', d);
                                    job.setTargetDate(d);
                                    job = job;
                                }}
                            />
                            {#if job.getTargetDate() !== null && targetHover}
                                <IconRemoveFilter
                                    on:click={() => {
                                        job.setTargetDate(null);
                                        job = job;
                                        return true;
                                    }}
                                />
                            {/if}
                        </div>
                    </VehicleOneValue>
                </VehicleOneSection>
                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('job_time_window')}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <div
                            style="display:flex; flex-direction: row; column-gap: 10px; align-items: center;"
                        >
                            <SelectHour
                                valid={JobValidator.checkStartEndOfTimeWindow(job)}
                                withBorder={false}
                                canBeEmpty={true}
                                hour={job.getStartOfTimeWindow() || ''}
                                onChange={h => {
                                    job.updateSpecialAttributeValue(
                                        'start_of_time_window',
                                        h || null
                                    );
                                    job = job;
                                    return true;
                                }}
                            />
                            -
                            <SelectHour
                                withBorder={false}
                                canBeEmpty={true}
                                hour={job.getEndOfTimeWindow() || ''}
                                valid={JobValidator.checkStartEndOfTimeWindow(job)}
                                onChange={h => {
                                    job.updateSpecialAttributeValue(
                                        'end_of_time_window',
                                        h || null
                                    );
                                    job = job;
                                    return true;
                                }}
                            />
                        </div>
                    </VehicleOneValue>
                </VehicleOneSection>

                <div
                    style="display: flex; align-items: center; flex-direction: row; column-gap: 10px;"
                >
                    <VehicleOneSection>
                        <VehicleOneLabel>
                            {$_('earliest_delivery_date')}
                        </VehicleOneLabel>
                        <VehicleOneValue>
                            <div
                                style="display: flex; align-items: center; flex-direction: row; column-gap: 10px; justify-content: flex-start; width: 100%;"
                            >
                                <span
                                    style="font-size: var(--font-size-tactical-plan); position: relative;"
                                    on:mouseenter={() => {
                                        earliestHover = true;
                                    }}
                                    on:mouseleave={() => {
                                        earliestHover = false;
                                    }}
                                >
                                    <SelectDay
                                        valid={JobValidator.checkEarliestBeforeLatestDeliveryDate(
                                            job
                                        )}
                                        minDay={new Date().toISOString().substring(0, 10)}
                                        showRelativeToday={$clientSettings.display
                                            .showRelativeToday}
                                        day={job.getEarliestDeliveryDate() || ''}
                                        onChange={d => {
                                            job.updateSpecialAttributeValue(
                                                'earliest_delivery_date',
                                                d || null
                                            );
                                            job = job;
                                            return true;
                                        }}
                                    />
                                    {#if job.getEarliestDeliveryDate() && earliestHover}
                                        <IconRemoveFilter
                                            on:click={() => {
                                                job.updateSpecialAttributeValue(
                                                    'earliest_delivery_date',
                                                    null
                                                );
                                                job = job;
                                                return true;
                                            }}
                                        />
                                    {/if}
                                </span>
                            </div>
                        </VehicleOneValue>
                    </VehicleOneSection>

                    <VehicleOneSection>
                        <VehicleOneLabel>
                            {$_('latest_delivery_date')}
                        </VehicleOneLabel>
                        <VehicleOneValue>
                            <div
                                style="display: flex; align-items: center; flex-direction: row; column-gap: 10px; justify-content: flex-start; width: 100%;"
                            >
                                <span
                                    style="font-size: var(--font-size-tactical-plan); position: relative;"
                                    on:mouseenter={() => {
                                        latestHover = true;
                                    }}
                                    on:mouseleave={() => {
                                        latestHover = false;
                                    }}
                                >
                                    <SelectDay
                                        valid={JobValidator.checkEarliestBeforeLatestDeliveryDate(
                                            job
                                        )}
                                        minDay={new Date().toISOString().substring(0, 10)}
                                        showRelativeToday={$clientSettings.display
                                            .showRelativeToday}
                                        day={job.getLatestDeliveryDate() || ''}
                                        onChange={d => {
                                            job.updateSpecialAttributeValue(
                                                'latest_delivery_date',
                                                d || null
                                            );
                                            job = job;
                                            return true;
                                        }}
                                    />
                                    {#if job.getLatestDeliveryDate() && latestHover}
                                        <IconRemoveFilter
                                            on:click={() => {
                                                job.updateSpecialAttributeValue(
                                                    'latest_delivery_date',
                                                    null
                                                );
                                                job = job;
                                                return true;
                                            }}
                                        />
                                    {/if}
                                </span>
                            </div>
                        </VehicleOneValue>
                    </VehicleOneSection>
                </div>
            </div>
        </VehicleOneParagraph>

        <VehicleOneParagraph>
            <div slot="title">{$_('Zlecenie')}</div>
            <div slot="content">
                <div
                    style="display: flex; align-items: center; flex-direction: row; column-gap: 10px;"
                >
                    <VehicleOneSection>
                        <VehicleOneLabel>
                            {$_('Typ zlecenia')}
                        </VehicleOneLabel>
                        <VehicleOneValue>
                            <Select
                                items={jobTypeItems}
                                selected="delivery"
                                onChange={e => {
                                    job.updateSpecialAttributeValue('delivery_or_collection', e);
                                    job = job;
                                    return true;
                                }}
                            />
                        </VehicleOneValue>
                    </VehicleOneSection>

                    <VehicleOneSection>
                        <VehicleOneLabel>
                            {$_('Nazwa zlecenia')}
                        </VehicleOneLabel>
                        <VehicleOneValue>
                            <InputText
                                valid={true}
                                style="width: 100%; max-width: 220px;"
                                value={job.getLabel() || ''}
                                on:change={e => {
                                job.updateSpecialAttributeValue('label', e.target?.value || '');
                                job = job;
                            }}
                                on:focusout={e => {
                                job.updateSpecialAttributeValue('label', e.target?.value || '');
                                job = job;
                            }}
                            />
                        </VehicleOneValue>
                    </VehicleOneSection>
                </div>
            </div>
        </VehicleOneParagraph>


        <VehicleOneParagraph>
            <div slot="title">{$_('Address')}</div>
            <div slot="content" style="flex-direction: row;">
                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('City')}{#if !job.coordsSetManually()}*{/if}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <InputText
                            valid={JobValidator.checkCityNotEmpty(job) || job.coordsSetManually()}
                            style="width: 100%; max-width: 220px;"
                            value={job.getData()?.address_attributes?.city || ''}
                            on:change={e => {
                                job.updateAddressAttributeValue('city', e.target?.value || '');
                                job = job;
                            }}
                            on:focusout={e => {
                                job.updateAddressAttributeValue('city', e.target?.value || '');
                                job = job;
                            }}
                        />
                    </VehicleOneValue>
                </VehicleOneSection>

                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('Street')}{#if !job.coordsSetManually()}*{/if}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <InputText
                            valid={JobValidator.checkStreetNotEmpty(job) || job.coordsSetManually()}
                            style="width: 100%; max-width: 220px;"
                            value={job.getData()?.address_attributes?.street || ''}
                            on:change={e => {
                                job.updateAddressAttributeValue('street', e.target?.value || '');
                                job = job;
                            }}
                            on:focusout={e => {
                                job.updateAddressAttributeValue('street', e.target?.value || '');
                                job = job;
                            }}
                        />
                    </VehicleOneValue>
                </VehicleOneSection>

                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('House')}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <InputText
                            style="width: 100%; max-width: 220px;"
                            value={job.getData()?.address_attributes?.house || ''}
                            on:change={e => {
                                job.updateAddressAttributeValue('house', e.target?.value || '');
                                job = job;
                            }}
                            on:focusout={e => {
                                job.updateAddressAttributeValue('house', e.target?.value || '');
                                job = job;
                            }}
                        />
                    </VehicleOneValue>
                </VehicleOneSection>

                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('Apartment')}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <InputText
                            style="width: 100%; max-width: 220px;"
                            value={job.getData()?.address_attributes?.apartment || ''}
                            on:change={e => {
                                job.updateAddressAttributeValue('apartment', e.target?.value || '');
                                job = job;
                            }}
                            on:focusout={e => {
                                job.updateAddressAttributeValue('apartment', e.target?.value || '');
                                job = job;
                            }}
                        />
                    </VehicleOneValue>
                </VehicleOneSection>

                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('Postal code')}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <InputText
                            style="width: 100%; max-width: 220px;"
                            value={job.getData()?.address_attributes?.pcode || ''}
                            on:change={e => {
                                job.updateAddressAttributeValue('pcode', e.target?.value || '');
                                job = job;
                            }}
                            on:focusout={e => {
                                job.updateAddressAttributeValue('pcode', e.target?.value || '');
                                job = job;
                            }}
                        />
                    </VehicleOneValue>
                </VehicleOneSection>

                <!--<VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('province')}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <InputText
                            style="width: 100%; max-width: 220px;"
                            value={job.getData()?.address_attributes?.province || ''}
                            on:change={e => {
                                job.updateAddressAttributeValue('province', e.target?.value || '');
                                job = job;
                            }}
                            on:focusout={e => {
                                job.updateAddressAttributeValue('province', e.target?.value || '');
                                job = job;
                            }}
                        />
                    </VehicleOneValue>
                </VehicleOneSection>

                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('community')}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <InputText
                            style="width: 100%; max-width: 220px;"
                            value={job.getData()?.address_attributes?.community || ''}
                            on:change={e => {
                                job.updateAddressAttributeValue('community', e.target?.value || '');
                                job = job;
                            }}
                            on:focusout={e => {
                                job.updateAddressAttributeValue('community', e.target?.value || '');
                                job = job;
                            }}
                        />
                    </VehicleOneValue>
                </VehicleOneSection>-->

                <VehicleOneSection>
                    <ButtonSmallBlack text={$_('Set on the map')} on:click={startPointOnMap} />
                </VehicleOneSection>

                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('phone')}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <InputText
                            style="width: 100%; max-width: 220px;"
                            value={job.getData()?.special_attributes?.phone || ''}
                            on:change={e => {
                                job.updateSpecialAttributeValue('phone', e.target?.value || '');
                                job = job;
                            }}
                            on:focusout={e => {
                                job.updateSpecialAttributeValue('phone', e.target?.value || '');
                                job = job;
                            }}
                        />
                    </VehicleOneValue>
                </VehicleOneSection>
            </div>
        </VehicleOneParagraph>

        <!--
            special_attributes: z.object({
            type: z.union([z.string(),z.array(z.string())]).nullable().catch(null),
            phone: z.string().nullable().catch(null),
            parcels: z.coerce.number().nullable().catch(null),
            total_weight: z.coerce.number().nullable().catch(null),
            deliverydelay: z.coerce.string().nullable().catch(null),
            fill_percentage: z.coerce.number().nullable().catch(null),
            end_of_time_window: z.string().nullable().catch(null),
            external_id: z.coerce.string().nullable().catch(null),
            latest_delivery_date: z.string().nullable().catch(null),
            start_of_time_window: z.string().nullable().catch(null),
            delivery_or_collection: z.string().nullable().catch(null),
            earliest_delivery_date: z.string().nullable().catch(null),
            orderCreatedDate: z.string().nullable().catch(null),
        }).nullable().catch(null),
        -->

        <VehicleOneParagraph>
            <div slot="title">{$_('shipment')}</div>
            <div slot="content">
                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('parcels')}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <InputNumber
                            valid={JobValidator.checkNumberOfParcelsIsPositive(job)}
                            style="width: 100%;"
                            value={job.getData()?.special_attributes?.parcels?.toString() || ''}
                            on:change={e => {
                                job.updateSpecialAttributeValue('parcels', e.target?.value || '');
                                job = job;
                            }}
                            on:focusout={e => {
                                job.updateSpecialAttributeValue('parcels', e.target?.value || '');
                                job = job;
                            }}
                        />
                    </VehicleOneValue>
                </VehicleOneSection>

                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('total_weight')}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <InputNumber
                            valid={JobValidator.checkIfTotalWeightIsPositive(job)}
                            style="width: 100%;"
                            value={job.getData()?.special_attributes?.total_weight?.toString() ||
                                ''}
                            on:change={e => {
                                job.updateSpecialAttributeValue(
                                    'total_weight',
                                    e.target?.value || ''
                                );
                                job = job;
                            }}
                            on:focusout={e => {
                                job.updateSpecialAttributeValue(
                                    'total_weight',
                                    e.target?.value || ''
                                );
                                job = job;
                            }}
                        />
                        kg
                    </VehicleOneValue>
                </VehicleOneSection>
                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('fill_percentage')}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <InputNumber
                            valid={JobValidator.checkFillPercentageBetween0And100(job)}
                            style="width: 100%;"
                            value={job.getData()?.special_attributes?.fill_percentage?.toString() ||
                                ''}
                            on:change={e => {
                                job.updateSpecialAttributeValue(
                                    'fill_percentage',
                                    e.target?.value || ''
                                );
                                job = job;
                            }}
                            on:focusout={e => {
                                job.updateSpecialAttributeValue(
                                    'fill_percentage',
                                    e.target?.value || ''
                                );
                                job = job;
                            }}
                        />
                        %
                    </VehicleOneValue>
                </VehicleOneSection>

                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('external_id')}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <InputText
                            style="width: 100%;"
                            value={job.getData()?.special_attributes?.external_id || ''}
                            on:change={e => {
                                job.updateSpecialAttributeValue(
                                    'external_id',
                                    e.target?.value || ''
                                );
                                job = job;
                            }}
                            on:focusout={e => {
                                job.updateSpecialAttributeValue(
                                    'external_id',
                                    e.target?.value || ''
                                );
                                job = job;
                            }}
                        />
                    </VehicleOneValue>
                </VehicleOneSection>
            </div>
        </VehicleOneParagraph>

        <VehicleOneParagraph>
            <div slot="title">{$_('Atrybuty dodatkowe')}</div>
            <div slot="content" style="flex-direction: column">
                <table class="client-attributes">
                    <tr>
                        <th><VehicleOneLabel>{$_('Nazwa atrybutu')}</VehicleOneLabel></th>
                        <th><VehicleOneLabel>{$_('Wartość atrybutu')}</VehicleOneLabel></th>
                        <th>&nbsp;</th>
                    </tr>
                    {#each Object.entries(clientAttributes) as [key, value]}
                        <tr>
                            <td style="padding-left: 8px;">
                                {key}
                            </td>
                            <td>
                                <InputText bind:value={value} on:change={e => {
                                    job.updateClientAttributeValue(key, e.target?.value || '');
                                    job = job;
                                }}/>
                            </td>
                            {#if (job.getData()?.id ?? 0) <= 0}
                                <td>
                                    <IconRemove scale={0.7} on:click={() => onClientAttributeRemove(key)}/>
                                </td>
                            {/if}
                        </tr>
                    {/each}
                    {#if (job.getData()?.id ?? 0) <= 0}
                        <tr>
                            <td>
                                <InputSuggest bind:this={newClientAttributeInput} bind:value={newClientAtrributeName} suggestions={allClientAttributes} valid={newClientAttributeValid} on:input={() => {
                                    console.log('JobEditForm, on:input', newClientAtrributeName);
                                    newClientAttributeValid = !(newClientAtrributeName in clientAttributes);
                                }}/>
                            </td>
                            <td>
                                <InputText bind:value={newClientAtrributeValue} on:keydown={(e) => {
                                    if (e.key === "Enter") {
                                        onClientAttributeAdd();
                                    }
                                }}/>
                            </td>
                            <td>
                                <IconAddSimple scale={0.7} on:click={onClientAttributeAdd}/>
                            </td>
                        </tr>
                    {/if}
                </table>
                {#if (job.getData()?.id ?? 0) <= 0}
                    <VehicleOneLabel>{$_('Wybierz pola widoczne dla kierowcy')}</VehicleOneLabel>
                    <DualList bind:items={attributeVisibility}/>
                {/if}
            </div>
        </VehicleOneParagraph>

        <div
            style="display: flex; justify-content: flex-end; margin:10px 40px; column-gap: 15px;align-items: center;"
        >
            {#if savingError}
                <div style="padding: 0 30px;">
                    <TemplateRow justifyContent="flex-start">
                        <!--                        <MessageDangerSmall message={savingError} />-->
                        <ErrorInline text={$_(savingError)} />
                    </TemplateRow>
                </div>
            {/if}
            {#if validateError}
                <div style="padding: 0 30px;">
                    <TemplateRow justifyContent="flex-start">
                        <ErrorInline text={$_(validateError)} />
                        <!--                        <MessageDangerSmall message={validateError} />-->
                    </TemplateRow>
                </div>
            {/if}
            {#if job.getData()?.geom && job.getData()?.geom?.coordinates}
                <IconLocationOn
                    on:click={() => {
                        console.log('job.geom', job.getData()?.geom);
                        if (job.getData()?.geom && job.getData()?.geom?.coordinates) {
                            Targeo.Base.Map.zoomAndCenter(
                                {
                                    x: job.getData()?.geom?.coordinates[0],
                                    y: job.getData()?.geom?.coordinates[1],
                                },
                                21
                            );
                            //jobsOnMap.jobShowBalloon(job.id);
                        }
                    }}
                />
            {:else if triedToSave && !saving}
                <div style="opacity:0.5; display: flex;">
                    <ErrorInline text={$_('No coordinates')} />
                    <ErrorColor>
                        <IconLocationOn />
                    </ErrorColor>
                </div>
            {/if}

            {#if saving}
                <IconPending spin={true} scale={0.7} />
            {/if}
            {#if savedWithSuccess}
                <SuccessInline text={$_('Saved')} />
            {/if}
            <ButtonMain
                text={job.coordsSetManually() ? $_('Save and close') : $_('Save and close')}
                disabled={saving || validateError !== ''}
                on:click={() => {
                    console.log('Saving job', job);
                    saveJob(!job.coordsSetManually() || job.getData().address_id === null);
                }}
            />
        </div>
    </div>
{/if}

{#if $debug}
    <pre>{JSON.stringify(job.getData(), null, 2)}</pre>
{/if}

<style>
    .job-edit-form {
        background-color: var(--section-background);
        border-radius: 6px;
        padding: 20px 0;
        margin: 10px 0;
    }
    .client-attributes th {
        text-align: left;
        font-weight: normal;
    }
    .client-attributes td :global(input) {
        width: 100%;
    }
</style>
